import { isNonEmptyArray } from '../../utils/checks'

export const getCustomLocationFaqs = ({
  faqs,
  allLocationsWithParents,
  locationParts
}) => {
  const customFAQs = [
    ...faqs,
    ...getFAQFromLocationParts({ locationParts, allLocationsWithParents })
  ].filter((faq) => faq.answer)

  return customFAQs
}

export const getFAQFromLocationParts = ({
  locationParts,
  allLocationsWithParents
}) => {
  if (!isNonEmptyArray(locationParts)) {
    return []
  }
  const faqs = locationParts.map((part) => {
    const location = allLocationsWithParents.find(
      (loc) => loc.node.title === part.title
    )
    return location?.node?.faqs ?? []
  })

  return faqs
}
